export const questionBlockContent = {
  main: {
    title: 'Ответы на вопросы',
    description: 'Мы позаботились о вас и собрали часто\nзадаваемые вопросы',
    ariaLabel: 'Часто задаваемые вопросы на главной странице',
    items: [
      {
        question: 'Что включает в себя детейлинг автомобиля?',
        answer:
          'Детейлинг включает глубокую очистку кузова и салона, бережную полировку, нанесение защитных составов и обработку труднодоступных зон, чтобы сохранить внешний вид и состояние автомобиля.',
      },
      {
        question: 'Чем отличается детейлинг от обычного ухода за автомобилем?',
        answer:
          'Обычный уход направлен на базовую чистоту, а детейлинг - на детальную проработку каждого элемента, восстановление внешнего вида и долговременную защиту материалов.',
      },
      {
        question: 'Как часто нужно делать детейлинг?',
        answer:
          'Рекомендуем проводить комплексный детейлинг 1-2 раза в год. Поддерживающие процедуры можно делать чаще в зависимости от пробега, сезона и условий эксплуатации.',
      },
      {
        question: 'Можно ли заказать только детейлинг салона автомобиля?',
        answer:
          'Да, можно выбрать отдельную услугу только для салона: химчистку, очистку пластика и кожи, обработку защитными средствами и устранение запахов.',
      },
      {
        question: 'Какие средства используются при детейлинге?',
        answer:
          'Используем профессиональные pH-сбалансированные составы, безопасные очистители и защитные покрытия, которые подбираются индивидуально под тип поверхности вашего авто.',
      },
    ],
  },
  services: {
    default: [
      {
        question: 'Сколько времени занимает выполнение услуги?',
        answer:
          'Срок зависит от сложности работ и состояния автомобиля. После осмотра мы называем точные сроки и фиксируем их перед началом работ.',
      },
      {
        question: 'Можно ли выбрать только часть работ?',
        answer:
          'Да, услугу можно собрать под ваш запрос: от локальной процедуры до полного комплекса. Мы поможем подобрать оптимальный формат.',
      },
      {
        question: 'Какая гарантия на выполненные работы?',
        answer:
          'Мы используем проверенные материалы и технологические карты. По каждой услуге объясняем правила ухода и срок сохранения результата.',
      },
    ],
    himchistka: [
      {
        question: 'Нужно ли разбирать салон для химчистки?',
        answer:
          'Разбор делается по необходимости и только для доступа к труднодоступным зонам. Финальный объем работ согласовывается с вами заранее.',
      },
      {
        question: 'Уходят ли сложные запахи после химчистки?',
        answer:
          'В большинстве случаев запахи заметно снижаются или исчезают. Для стойких случаев применяем дополнительную обработку и озонирование.',
      },
      {
        question: 'Когда можно пользоваться машиной после химчистки?',
        answer:
          'Обычно автомобиль готов к эксплуатации в день выдачи. Мы подскажем точное время высыхания по результату конкретного кейса.',
      },
    ],
  },
  subServices: {
    default: [
      {
        question: 'Подходит ли эта подуслуга для моего авто?',
        answer:
          'Перед началом мы оцениваем состояние автомобиля и подбираем безопасную технологию под конкретные материалы и тип покрытия.',
      },
      {
        question: 'Можно ли совместить эту подуслугу с другими работами?',
        answer:
          'Да, многие подуслуги хорошо комбинируются. Мы составим план, чтобы получить максимальный эффект за один визит.',
      },
      {
        question: 'Как подготовить автомобиль к записи?',
        answer:
          'Достаточно приехать в согласованное время. При необходимости мы заранее дадим рекомендации по подготовке именно к этой процедуре.',
      },
    ],
    'himchistka-s-razborom': [
      {
        question: 'Что входит в химчистку с разбором?',
        answer:
          'В услугу входит детальная очистка салона с доступом к скрытым зонам, где обычно скапливаются пыль, грязь и остатки влаги.',
      },
      {
        question: 'Безопасен ли разбор элементов салона?',
        answer:
          'Да, мы работаем по регламенту и аккуратно демонтируем только необходимые элементы, чтобы сохранить заводское состояние деталей.',
      },
      {
        question: 'Сколько времени занимает процедура?',
        answer:
          'Это одна из самых глубоких процедур, поэтому обычно занимает больше времени, чем стандартная химчистка. Точный срок сообщаем после осмотра.',
      },
    ],
  },
}

export const getServiceQuestions = (serviceSlug) =>
  questionBlockContent.services[serviceSlug] || questionBlockContent.services.default

export const getSubServiceQuestions = (subServiceSlug) =>
  questionBlockContent.subServices[subServiceSlug] || questionBlockContent.subServices.default
